import { render, staticRenderFns } from "./CardChatContact.vue?vue&type=template&id=91022594&scoped=true&"
import script from "./CardChatContact.vue?vue&type=script&lang=js&"
export * from "./CardChatContact.vue?vue&type=script&lang=js&"
import style0 from "./CardChatContact.vue?vue&type=style&index=0&id=91022594&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91022594",
  null
  
)

export default component.exports